import * as Sentry from "@sentry/react"
import {Middleware} from "@reduxjs/toolkit"

export const sentryReduxMiddleware: Middleware = store => next => action => {
    try {
        const result = next(action)

        // Capture rejected RTK Query actions
        if (action.type?.endsWith("/rejected")) {
            Sentry.withScope((scope: any) => {
                scope.setTag("redux-action", action.type)
                scope.setExtra("action", action)

                const state = store.getState()

                scope.setContext("redux_state", {
                    auth: state.auth,
                    user: state.user,
                })

                Sentry.captureException(action.error)
            })
        }

        return result
    } catch (error) {
        Sentry.captureException(error)
        throw error
    }
}
